import {createApp} from 'vue';
import ProjectNameModal from '../../components/ProjectNameModal.vue';

document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('.open-project-name[data-config]');
    if (buttons.length === 0) {
        return;
    }

    const el = document.createElement('div');
    document.body.appendChild(el);
    createApp(ProjectNameModal).mount(el);

    for (const button of buttons) {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            window.openProjectNameModal(JSON.parse(button.dataset.config));
        });
    }
});
